import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "./css/App.css";
import "./css/normalize.css";
import "./css/webflow.css";
import "./css/edutools.webflow.css";
import NotFound from "./pages/NotFound";
import Cancel from "./pages/Cancel";
import DownloadApp from "./pages/DownloadApp";
import Failure from "./pages/Failure";
import Home from "./pages/Home";
import HyperLinks from "./pages/HyperLinks";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Disclaimer from "./pages/Disclaimer";
import Success from "./pages/Success";
import Login from "./pages/Login";
import LoginSuccess from "./pages/LoginSuccess";
import GetStarted from "./pages/GetStarted";
import LaunchEdutools from "./pages/LaunchEdutools";
import Info from "./pages/Info";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Greek from "./pages/Greek";
import Org from "./pages/Org";
import Account from "./pages/Account";
import ContactForm from "./pages/ContactForm";
import Timeline from "./pages/Timeline";
import AuthCheck from "./pages/AuthCheck";
import {
  applyPerformanceOptimizations,
  optimizeImages,
} from "./utils/performanceUtils";

function App() {
  // Apply performance optimizations
  useEffect(() => {
    // Apply device-specific optimizations
    applyPerformanceOptimizations();

    // Optimize images after the page has loaded
    window.addEventListener("load", optimizeImages);

    // Debug: Detect Puppeteer/Electron environment
    if (window.__EDUTOOLS_PUPPETEER__) {
      console.log('[App] Running inside EduTools Electron environment');
    }

    return () => {
      window.removeEventListener("load", optimizeImages);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/login-success" element={<LoginSuccess />} />
          <Route path="/launch-edutools" element={<LaunchEdutools />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/download" element={<DownloadApp />} />
          <Route path="/failure" element={<Failure />} />
          <Route path="/success" element={<Success />} />
          <Route path="/qr-3tV8jZ9" element={<Info />} />
          <Route path="/123hyperlinks123" element={<HyperLinks />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/greek" element={<Greek />} />
          <Route path="/org" element={<Org />} />
          <Route path="/account" element={<Account />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/auth-check" element={<AuthCheck />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
